import styled, { keyframes, css } from "styled-components";

import {
  whiteBgOnClickAnim,
  scaleOnClickAnim,
  textClickAnim,
} from "../../animations";
// ANIMATIONS
const btnSwitch = keyframes`
    0% {
    transform: translateZ(0) scale(1);
    background: transparent;
    color: #ffb000;
    animation-timing-function: cubic-bezier(0.33, 1, 0, 0);
  }
  33% {
    transform: translateZ(0) scale(0.65);
    background: #ffb000;
    color: red;
    animation-timing-function: cubic-bezier(0.1, 0, 0, 1);
  }
  66% {
    background: #ffb000;
    color: red;
    transform: translateZ(0) scale(1);
  }
`;
// const btnSwitchReverse = keyframes`
/* 0% {
      background: #ffb000;
    color: red;
    animation-timing-function: cubic-bezier(0.1, 0, 0, 1);
  }
  33% {
    background: transparent;
    color: #ffb000;
    animation-timing-function: cubic-bezier(0.33, 1, 0, 0);
  }
  66% {
    background: transparent;
    color: #ffb000;
  } */
// `;
const btnSwitchAnim = css`
  ${btnSwitch}
`;
// const btnSwitchReverseAnim = css`
//   ${btnSwitchReverse}
// `;
//
export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  margin-bottom: 20px;
`;

export const Column = styled.div`
  width: 50%;
  position: relative;
  :first-child {
    /* margin-right: 5px; */
    margin-right: 10px;
  }
  .infinite {
    /* height: 48px; */
    width: 20px;
    bottom: 0;
    position: absolute;
    /* left: 15px; */
    pointer-events: none;
    height: 56px;
    left: 24px;
  }
  /* @media only screen and (min-width: 375px) {
    :first-child {
      margin-right: 10px;
    }
    .infinite {
      height: 56px;
      left: 24px;
    }
  } */
`;
export const Text = styled.div`
  /* font-size: 8px; */
  font-size: 10px;
  text-transform: uppercase;
  margin-bottom: 14px;
  /* @media only screen and (min-width: 375px) {
    font-size: 10px;
  } */
`;
export const InputM = styled.input`
  background: transparent;
  border: solid 3px #ffb000;
  border-radius: 38px;
  /* padding: 0 15px; */
  overflow: hidden;
  text-overflow: ellipsis;
  outline: none;
  color: #ffb000;
  width: 100%;
  /* height: 48px; */
  font-size: 12px;
  max-width: 149px;
  padding: 0 24px;
  height: 56px;
  -webkit-appearance: none;
  ::placeholder {
    color: #ffb000;
    opacity: 0.8;
  }
  /* @media only screen and (min-width: 375px) {
    max-width: 149px;
    padding: 0 24px;
    height: 56px;
  } */
`;
export const BallContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto auto auto auto;
  /* grid-row-gap: 4px;
  grid-column-gap: 4px; */
  margin: 32px auto;
  grid-row-gap: 9px;
  grid-column-gap: 9px;
  pointer-events: ${(p) => (p.isDisabled ? "none" : "auto")};
  /* @media only screen and (min-width: 375px) {
    grid-row-gap: 9px;
    grid-column-gap: 9px;
  } */
`;

export const Ball = styled.div`
  border-radius: 50%;
  /* width: 48px;
  height: 48px; */
  width: 56px;
  height: 56px;
  position: relative;
  transition: all 0.15s;
  span {
    position: absolute;
    width: 100%;
    height: 100%;
    border: solid 3px #233b50;
    border-radius: 50%;
    transform: scale(1);
    background: transparent;
    transition: all 0.15s;
  }
  &&.selected {
    animation: borderAnim 0.15s forwards;
    span {
      background: #233b50;
      border: solid 3px #233b50;
      animation: backgroundAnim 0.15s forwards;
    }
  }
  /* @media only screen and (min-width: 375px) {
    width: 56px;
    height: 56px;
  } */
  @keyframes borderAnim {
    0% {
      transform: scale(1);
      animation-timing-function: cubic-bezier(0.33, 1, 0, 0);
    }
    100% {
      transform: scale(0.8928);
    }
  }
  @keyframes backgroundAnim {
    0% {
      opacity: 0;
      animation-timing-function: cubic-bezier(0.4, 1, 0, 1);
    }
    100% {
      opacity: 1;
    }
  }
`;
export const Title = styled.div`
  font-size: 20px;
  text-transform: uppercase;
  color: #233b50;
  text-align: center;
  margin-bottom: 46px;
`;
export const BackBtn = styled.div`
  font-size: 20px;
  color: #ffb000;
  text-transform: uppercase;
  text-align: center;
  margin-top: 24px;
  cursor: pointer;
  animation: ${(p) => (p.backA ? textClickAnim : null)};
  animation-duration: 0.5s;
  pointer-events: ${(p) => (p.isDisabled ? "none" : "auto")};
`;

export const PlayBtn = styled.div`
  background: #ffb000;
  border: solid 3px #ffb000;
  border-radius: 38px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: #ff3920;
  text-transform: uppercase;
  font-size: 20px;
  position: relative;
  cursor: pointer;
  pointer-events: ${(p) => (p.isDisabled ? "none" : "auto")};
  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    transform: scale(1);
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    opacity: 0;
    right: 50%;
    bottom: 50%;
    transform: translate(50%, 50%);
    width: 100%;
    height: 100%;
    animation: ${(p) => (p.playA ? whiteBgOnClickAnim : null)};
    animation-duration: 0.5s;
  }
  animation: ${(p) => (p.playA ? scaleOnClickAnim : null)};
  animation-duration: 0.5s;
`;

export const Balance = styled.div`
  color: #ffb000;
  position: relative;
  border-radius: 38px;
  border: solid 3px #ffb000;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap-reverse;
  width: 100%;
  font-size: 12px;
  height: 56px;
  max-width: 178px;
  margin: 0px;
  padding: 10px;
  &&.inputM {
    text-overflow: ellipsis;
    max-width: 149px;
  }
  input {
    outline: none;
    background: none;
    border: none;
    width: 80%;
    text-overflow: ellipsis;
    font-size: 12px;
    margin-right: 5px;
    padding-right: 5px;
    color: #ffb000;
    align-items: center;
    text-align: center;
    ::placeholder {
      color: #fbb000;
    }
  }
  svg {
    position: absolute;
    right: 10%;
  }
`;

export const Btn = styled.div`
  height: 56px;
  width: 56px;
  font-size: 20px;
  border-radius: 50%;
  border: solid 2px #ffb000;
  background: #ffb000;
  color: #ff3920;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  position: relative;

  svg {
    height: 24px;
    width: 24px;
  }
  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 50%;
    opacity: 0;
    right: 50%;
    bottom: 50%;
    transform: translate(50%, 50%);
    width: 100%;
    height: 100%;
    ${(p) =>
      p.plusPress || p.minusPress
        ? "opacity: 0.5;  transition-timing-function: cubic-bezier(0, 0, 0.2, 1); trantision: opacity 0.25s;"
        : "opacity: 0;  transition-timing-function: cubic-bezier(0.7, 0.2, 0.3, 0); transition: opacity 0.25s"}
  }
  ${(p) =>
    p.plusPress || p.minusPress
      ? "transform: scale(0.65); transition-timing-function: cubic-bezier(0.33, 1, 0, 0); transition: transform 0.25s;"
      : "transform: scale(1); transition-timing-function: cubic-bezier(0.1, 0, 0, 1); transition: transform 0.25s;"};
`;

export const InputBox = styled.div`
  border-radius: 38px;
  border: solid 3px #ffb000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  backface-visibility: hidden;
  height: 56px;
  font-size: 12px;
  margin-bottom: 20px;
  padding: 10px;
`;
export const Switch = styled.div`
  height: 100%;
  padding: 0 5px;
  margin-right: 5px;
  text-transform: uppercase;
  border-radius: 38px;
  border: solid 2.5px #ffb000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  position: relative;
  cursor: pointer;
  white-space: nowrap;
  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    transform: scale(1);
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    opacity: 0;
    right: 50%;
    bottom: 50%;
    transform: translate(50%, 50%);
    width: 100%;
    height: 100%;
    animation: ${(p) =>
      (p.lossAnim === "1" && p.active) || (p.winAnim === "1" && p.active)
        ? whiteBgOnClickAnim
        : (p.lossAnim === "0" && p.active) || (p.winAnim === "0" && p.active)
        ? whiteBgOnClickAnim
        : null};
    animation-duration: 0.5s;
  }
  ${(props) =>
    props.active
      ? "background: #ffb000; color: #ff3920;"
      : "background: transparent; color: #ffb000;"}
  /* es gadasaketebelia */
  animation: ${(p) =>
    (p.lossAnim === "1" && p.active) || (p.winAnim === "1" && p.active)
      ? btnSwitchAnim
      : (p.lossAnim === "0" && p.active) || (p.winAnim === "0" && p.active)
      ? btnSwitchAnim
      : null};
  animation-duration: 0.5s;
 
`;
export const InputSBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffb000;
  max-width: 80px;
  font-size: 18px;
  input {
    background: transparent;
    padding: 0 0 0 3px;
    overflow: hidden;
    text-overflow: ellipsis;
    border: none;
    outline: none;
    text-align: center;
    max-width: 70px;
    color: #ffb000;
    font-size: 16px;
    text-overflow: ellipsis;
    ::placeholder {
      color: #ffb000;
    }
  }

`;
